<template>
  <div>
    <el-card shadow="never">
      <template #header>
        <el-row class="serviceItemCard-header">
          <el-col :span="!!columnOptions[0] && !!columnOptions[0].span ? columnOptions[0].span : 5" :style="{'text-align': columnOptions[0].align}">
            {{data.ServiceItemName}}
          </el-col>
          <el-col :span="!!columnOptions[1] && !!columnOptions[1].span ? columnOptions[1].span : 4" :style="{'text-align': columnOptions[1].align}">
            <span v-if="data.EndDate">{{calcDateText(data.EndDate)}}</span>
            <span v-else>&nbsp;</span>
          </el-col>
          <el-col :span="!!columnOptions[2] && !!columnOptions[2].span ? columnOptions[2].span : 3" :style="{'text-align': columnOptions[2].align}">
            {{`${data.QuantityTotal !== -1 ? data.QuantityAvailable : '∞'}/${data.QuantityTotal !== -1 ? data.QuantityTotal : '∞'}${GLOBAL.enumSAQuantityType.getDesc(data.QuantityType)}`}}
          </el-col>
          <el-col :span="!!columnOptions[3] && !!columnOptions[3].span ? columnOptions[3].span : 4" :style="{'text-align': columnOptions[3].align}">
            {{data.SaleAmountAvailable|toCurrency(currency)}}
          </el-col>
          <el-col :span="!!columnOptions[4] && !!columnOptions[4].span ? columnOptions[4].span : 3" :style="{'text-align': columnOptions[4].align}">
            <span :class="calcStatusClass(data)">{{GLOBAL.enumStudyAbroadStatus.getDesc(data.Status)}}</span>
          </el-col>
          <el-col v-if="!readonly && data.Status !== GLOBAL.enumStudyAbroadStatus.Closed && data.Status !== GLOBAL.enumStudyAbroadStatus.Refund"
            :span="!!columnOptions[5] && !!columnOptions[5].span ? columnOptions[5].span : 5" :style="{'text-align': columnOptions[5].align}">
            <el-button v-if="data.Status !== GLOBAL.enumStudyAbroadStatus.Completed && !isAutoAttrition && hasQuantityAvailable" type="primary" size="mini" @click="addNCServiceRecord">添加服务记录</el-button>
            <el-button type="primary" size="mini" class="serviceItemCard-closeBtn" @click="closeSAWorkflowServiceItem">关闭小项</el-button>
          </el-col>
        </el-row>
      </template>
      <el-table :show-header="false" row-key="Id" :row-class-name="calcRowClass" :row-style="{'background-color': 'transparent'}"
        :cell-style="{'border-bottom': 0}" :data="data.NonCourseServiceRecordList">
        <el-table-column prop="CreateDate" label="添加日期" min-width="160" :formatter="(row, column, cellValue, index) => `添加日期: ${calcDateText(cellValue)}`" />
        <el-table-column label="服务日期" min-width="160">
          <template #default="{row}">
            <span v-if="row.RecordType !== GLOBAL.enumRecordType.ForceClose">{{`服务日期: ${calcDateText(row.ServiceDate)}`}}</span>
            <span v-else>{{`关闭日期: ${calcDateText(row.CloseDate)}`}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ServiceProvider" label="服务人员" min-width="100" />
        <el-table-column label="扣除次数/时数" min-width="70">
          <template #default="{row}">
            <span>-{{`${row.QuantityDeduction}${data.TimeLimitEnable ? "小时" : "次"}`}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SaleAmountDeduction" label="扣除额度" min-width="100"
          :formatter="(row, column, cellValue, index) => `-${Object.toCurrency(cellValue, row.Currency)}`" />
        <el-table-column prop="Comment" label="备注" min-width="240" />
        <el-table-column v-if="!readonly && data.Status !== GLOBAL.enumStudyAbroadStatus.Closed && data.Status !== GLOBAL.enumStudyAbroadStatus.Refund"
          label="操作" width="100">
          <template #default="{row}">
            <el-button v-if="row.RecordType === GLOBAL.enumRecordType.Normal" type="text" size="medium" @click="editNCServiceRecord(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import global_ from "@/core/global";

const mixin_generalMethods = {
  methods: {
    calcStatusClass(data) {
      return {
        "color-status": true,
        "color-status-inProgress":
          data.Status === this.GLOBAL.enumStudyAbroadStatus.InProgress,
        "color-status-completed":
          data.Status === this.GLOBAL.enumStudyAbroadStatus.Completed,
        "color-status-closed":
          data.Status === this.GLOBAL.enumStudyAbroadStatus.Closed ||
          data.Status === this.GLOBAL.enumStudyAbroadStatus.Refund,
      };
    },
    calcRowClass({row, rowIndex}) {
      return {
        "cs-redLabel": row.RecordType === this.GLOBAL.enumRecordType.ForceClose,
      };
    },
    calcDateText(value, format = "YYYY/MM/DD") {
      let mValue = this.$moment(value);
      if (!mValue.isValid()) return String.empty;

      return mValue.format(format);
    },
  },
};

const defaultColumnOptions = [
  {
    span: 5,
  },
  {
    span: 4,
  },
  {
    span: 3,
  },
  {
    span: 4,
  },
  {
    span: 3,
  },
  {
    span: 5,
    align: "right",
  },
];

const defaultData = {
  Id: 0,
  ServiceItemId: 0,
  ServiceItemName: null,
  ServiceType: 0,
  RangeLimitEnable: false,
  RangeLimitType: null,
  RangeLimitValue: null,
  CountLimitEnable: false,
  CountLimitType: null,
  CountLimitValue: null,
  TimeLimitEnable: false,
  TimeLimitType: null,
  TimeLimitValue: null,
  QuantityTotal: 0,
  QuantityAvailable: 0,
  CostAmountDiscounted: 0,
  SaleAmountDiscounted: 0,
  CostAmountUnit: 0,
  SaleAmountUnit: 0,
  CostAmountAvailable: 0,
  SaleAmountAvailable: 0,
  StartDate: null,
  EndDate: null,
  Status: 0,
  NonCourseServiceRecordList: [],
  QuantityType: 0,
};

const defaultNCServiceRecord = {
  Id: 0,
  CreateDate: new Date(),
  WorkflowServiceItemId: 0,
  ServiceDate: null,
  QuantityDeduction: 1,
  ServiceProvider: null,
  Comment: null,
  Currency: 0,
  CostAmountDeduction: 0,
  SaleAmountDeduction: 0,
  RecordType: 0
};

export default {
  name: "nonCourseServiceItemDetail",
  mixins: [mixin_generalMethods],
  props: {
    columnOptions: {
      type: Array,
      default: () => Object.clone(defaultColumnOptions),
    },
    currency: {
      type: Number,
      default: global_.currencyType.CNY,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => Object.clone(defaultData),
    },
  },
  data() {
    return {
      nonCourseServiceRecordEditorOptions: {
        visible: false,
        dataIn: Object.clone(defaultNCServiceRecord),
        isTimeQuantity: false,
        serviceHoursAvailable: 0,
      },
    };
  },
  computed: {
    isAutoAttrition: function(){
      return this.data.ServiceType === this.GLOBAL.enumSAServiceType.AutoAttrition;
    },
    hasQuantityAvailable: function(){
      if (this.data.QuantityTotal <= 0 || this.data.QuantityAvailable > 0){
        return true;
      }
      return false;
    }
  },
  methods: {
    closeSAWorkflowServiceItem() {
      this.$emit("close", this.data);
    },
    addNCServiceRecord() {
      this.$emit("addRecord", this.data);
    },
    editNCServiceRecord(row) {
      this.$emit("editRecord", row, this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card {
  background-color: whitesmoke;
  margin-bottom: 20px;

  .serviceItemCard-header {
    line-height: 28px;
    font-weight: bold;
  }

  .serviceItemCard-closeBtn{
    margin-top: 5px;
  }

  .serviceItemCard-action {
    text-align: right;
  }

  .el-table {
    background-color: transparent;
    position: inherit;
  }

  /deep/ .el-card__body {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/serviceItem/nonCourseServiceItemDetail.vue